import styled from '@emotion/styled/macro';
import rem from "../../../utils/rem/rem";

export const ChangeRawProductsBody = styled.div`
    padding: ${rem(32)};
    display: flex;
    flex-flow: column nowrap;
    gap: ${rem(16)};
`;

export const Row = styled.div`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    gap: ${rem(32)};
`;

export const ButtonRow = styled(Row)`
  flex-flow: row-reverse;
`;